<script>
import DateUtils from '@/utils/dateUtils'
import StringUtils from '@/utils/stringUtils'
import VueUtils from '@/utils/vueUtils'
import CalEventItem from './vue-calendar/components/cal-event-item'

export default
{
    name: 'calendar',

    props:
    {
        events: { type: Array, default: () => [] },
        editable: { type: Boolean, default: false }
    },

    render () 
    {
        return (
            <div>
                <vue-event-calendar events={this.events} on-day-changed={this.onDayChanged} on-month-changed={this.onMonthChanged}
                    title={this.title} ref='calendar' editable={this.editable} on-save-changes-clicked={this.onSaveChangesClicked}
                    on-add-new-event={this.onAddNewEvent} on-delete-clicked={this.onDeleteClicked} />
            </div>
        )
    },

    data: () =>
    ({
        title: undefined
    }),

    computed:
    {
        selectedDate ()
        {
            return this.$refs.calendar.selectedDayEvents.date
        },

        hasUnsavedModifications ()
        {
            return this.events.some(e => e.isUncreated) || VueUtils.getChildrenOfType(this, CalEventItem).some(i => i.hasEventBeenModified)
        }
    },

    mounted ()
    {
        this.selectAllEvents()
    },

    methods:
    {
        selectAllEvents ()
        {
            this.$refs.calendar.handleChangeCurDay('all')
        },

        onDayChanged (selectedDay)
        {
            if (selectedDay.date == 'all' || (selectedDay.events.length == 0 && !this.editable))
            {
                this.title = 'tous les événements'
                this.$refs.calendar.selectedDayEvents.date = 'all'
                this.$refs.calendar.selectedDayEvents.events = this.events
            }
            else
            {
                this.title = `${StringUtils.plural('événement', selectedDay.events)} du ` + DateUtils.dateToString(selectedDay.date, 'iso', 'fr')
            }
        },

        onMonthChanged ()
        {
            this.selectAllEvents()
        },

        onSaveChangesClicked (event, e, button)
        {
            this.$emit('save-changes-clicked', event, e, button)
        },

        onAddNewEvent ()
        {
            this.$emit('add-new-event')
        },

        async onDeleteClicked (event)
        {
            this.$emit('delete-clicked', event)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.__vev_calendar-wrapper
{
    .OnDesktop({
        height: 100vh;
    });

    .events-wrapper
    {
        .OnMobile({
            padding-bottom: var(--theme-horizontal-menu-height);
            min-height: 35vh;
        });

        .OnTablet({
            min-height: 50vh;
        });
        
        .event-item .title
        {
            font-family: Nunito;
        }

        .date
        {
            font-family: Nunito;
        }
    }

    .cal-wrapper .cal-header
    {
        .OnMobile({
            margin: 0 5px 0 5px;
            width: unset;
        });
    }

    .__vev_calendar-wrapper .events-wrapper .cal-events
    {
        .OnTablet({
            margin: unset;
        });
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue